import React from "react";
import ExternalIdentities from "components/externalidentities/externalidentities";
import EditViewPanel from "components/panels/EditViewPanel";
import { useLoaderData } from "react-router";
import RightSideNavigation from "../components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "../layout/TwoColumnLayout";
import ChangeNamePanelContent from "./ChangeName/ChangeNamePanelContent";
import ICalendarFeeds from "./ICalendarFeeds/components/app";
import { ChangePasswordItem } from "./changepassword/components";
import ChangeSecretQuestion from "./changesecretquestion/changeSecretQuestion";
import DefaultsPanel from "./defaults/defaultspanel";
import DisplayPanel from "./display/displaypanel";
import EsignSignatureSettings from "./eSignSignatureSettings/app";
import EmailSettings from "./emailsettings/components/app";
import NotificationSettingsComponent from "./notificationsettings/components/notificationsettingspanel";
import RegionalSettingsPanel from "./regionalsettings/regionalsettingspanel";
import FavoriteSubjects from "./favoriteSubjects/app";

const PersonalSettingsPage = (props: React.PropsWithChildren) => {
  return (
    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        {props.children}
      </TwoColumnLayout.LeftColumn>
      <RightSideNavigation
        title={desktopNavigation.rightSideNavigation.title}
        menuItems={desktopNavigation.rightSideNavigation.items}
        currentPage={desktopNavigation.currentPage}
        highlightActiveRoute
      />
    </TwoColumnLayout>
  );
}

export const ChangeNameApp = () => <PersonalSettingsPage>
  <EditViewPanel title={RESX.PersonalSettings.ChangeName}>
    <ChangeNamePanelContent />
  </EditViewPanel>
</PersonalSettingsPage>

export const ChangePasswordApp = () => <PersonalSettingsPage>
  <EditViewPanel
    title={RESX.PersonalSettings.ChangePassword}>
    <ChangePasswordItem />
  </EditViewPanel>
</PersonalSettingsPage>

export const ChangeSecretQuestionApp = () => <PersonalSettingsPage>
  <EditViewPanel
    title={RESX.PersonalSettings.ChangeSecretQuestion}>
    <ChangeSecretQuestion />
  </EditViewPanel>
</PersonalSettingsPage>

export const ConnectedAccountsApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PersonalSettingsModifyFrontModel>();

  return <PersonalSettingsPage>
    <EditViewPanel
      title={RESX.ConnectedAccount.ConnectedAccounts}
      articleId={serverReference.supportArticleIds.whatAreSocialLogins}
    >
      <ExternalIdentities
        allowDisconnect={true}
        googleConnectAbsolute={viewModel.googleConnectAbsolute}
      />
    </EditViewPanel>
  </PersonalSettingsPage>
}

export const FavoriteSubjectsApp = () => <PersonalSettingsPage>
  <FavoriteSubjects />
</PersonalSettingsPage>

export const EmailSettingsApp = () => <PersonalSettingsPage>
  <EmailSettings />
</PersonalSettingsPage>


export const SignatureSettingsApp = () => <PersonalSettingsPage>
  <EsignSignatureSettings />
</PersonalSettingsPage>


export const ICalendarFeedsApp = () => <PersonalSettingsPage>
  <ICalendarFeeds />
</PersonalSettingsPage>

export const LanguageAndRegionApp = () => <PersonalSettingsPage>
  <EditViewPanel
    title={RESX.PersonalSettings.LanguageAndRegion} >
    <RegionalSettingsPanel />
  </EditViewPanel>
</PersonalSettingsPage>

export const NotificationSettingsApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PersonalSettingsModifyFrontModel>();

  return <PersonalSettingsPage>
    <EditViewPanel
      title={RESX.Notifications.resxNotifications}>
      <NotificationSettingsComponent initialSettings={viewModel.notificationSettings} />
    </EditViewPanel>
  </PersonalSettingsPage>
}

export const DefaultsApp = () => <PersonalSettingsPage>
  <EditViewPanel
    title={RESX.PersonalSettings.DefaultsPreferences}>
    <DefaultsPanel />
  </EditViewPanel>
</PersonalSettingsPage>

export const FeatureConfigSettingsApp = () => <PersonalSettingsPage>
  <EditViewPanel
    title={RESX.PersonalSettings.FeatureConfiguration} >
    <DisplayPanel />
  </EditViewPanel>
</PersonalSettingsPage>